/**
 * Created by ray
 */

export class Constants {
  public base_url_api = 'https://service.nfsmith.com/svc-ds/api/';

  public option_keep_login_time = 86400000;

  public local_storage_login_user = 'nfsmith.auth.currentUser';
  public local_storage_login_date = 'nfsmith.auth.loginDate';
  public local_storage_expire_date = 'nfsmith.auth.expireDate';
  public local_storage_token_name = 'nfsmith.auth.token';


  public amazon_module_permission = 'ext-amazon-viewer';
  public inventory_module_permission = 'ext-inventory-viewer';
  public sales_module_permission = 'ext-sales-viewer';
  public invoice_module_permission = 'ext-invoice-viewer';
  public dell_module_permission = 'ext-dell-viewer';
  public hp_module_permission = 'ext-hp-viewer';
  public slt_smith_permission = 'ext-slt-smith';
  public slt_guest_permission = 'ext-slt-guest';
  public admin_module_permission = 'smith-admin';
  public seo_module_permission = 'ext-seo-viewer';
  public demo_module_permission = 'ext-demo-viewer';
  public dell_upload_module_permission = 'dell-upload-module';
  public quote_module_permission = 'ext-quote-viewer';
  public ext_google_permission = 'ext-quote-viewer';
  public fortinet_module_permission = 'fortinet_module';
  public fortinet_upload_module_permission = 'fortinet_upload_module';
  public trd_permission = 'ext-trd-viewer';

  public user_type_internal = 'Internal';
  public user_type_external = 'External';

  public lookup_ext_roles = 'ext-roles';
  public lookup_int_roles = 'int-roles';
  public lookup_country = 'country';
  public lookup_service_customer = 'service-customer';
  public lookup_mfg = 'mfg';
  public lookup_part_type = 'partType';
  public lookup_awb_url = 'awb-url';

  public init_load_data = true;

}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/constants.ts